<template>
  <validation-observer
    :style="style"
    class="flex flex-col flex-grow"
    tag="form"
    v-slot="{ handleSubmit }"
    @submit.prevent
  >
    <layout-container>
      <div class="p-6 bg-color">
        <div class="max-w-screen-sm mx-auto">
          <appointment-details
            :controls="control"
            :previous-step="previousStep"
            @back="$emit('back', $event)"
          />
          <form-group-patient
            :errors="errors"
            :controls="control"
            @input:group="onInput"
          >
            <h3 slot="group:title" class="w-full text-lg font-bold mb-2">
              A little bit about you
            </h3>
          </form-group-patient>
          <form-group-insurance
            class="mt-10"
            :errors="errors"
            :controls="control"
            @input:group="onInput"
          >
            <h3 slot="group:title" class="w-full text-lg font-bold mb-2">
              Do you have dental insurance?
            </h3>
          </form-group-insurance>
          <form-group-check-list
            class="mt-4 mb-5"
            :errors="errors"
            :controls="control"
            @input:group="onInput"
          >
          </form-group-check-list>
        </div>
      </div>
    </layout-container>

    <about-us-section :control="control" />

    <!-- Form Submit -->
    <layout-footer
      :location="control.locations"
      :previous-step="previousStep"
      @back="$emit('back', $event)"
    >
      <button-primary
        type="submit"
        class="w-full px-10 py-3 lg:w-auto lg:col-start-2 xl:col-start-3"
        @click="handleSubmit(onSubmit)"
        data-testid="submit-patientdetails"
      >
        Book Appointment
      </button-primary>
    </layout-footer>
  </validation-observer>
</template>

<script>
import Base from "@/components/StepBase";
import ButtonPrimary from "@/components/Button/ButtonPrimary";
import LayoutFooter from "@/components/Layout/LayoutFooter";
import LayoutContainer from "@/components/Layout/LayoutContainer";
import FormGroupInsurance from "@/components/FormGroup/FormGroupInsurance";
import FormGroupPatient from "@/components/FormGroup/FormGroupPatient";
import AppointmentDetails from "@/components/Info/AppointmentDetails.vue";
import FormGroupCheckList from "@/components/FormGroup/FormGroupCheckList.vue";
import AboutUsSection from "@/components/Info/AboutUsSection.vue";

export default {
  extends: Base,
  components: {
    AppointmentDetails,
    ButtonPrimary,
    LayoutFooter,
    LayoutContainer,
    FormGroupInsurance,
    FormGroupPatient,
    FormGroupCheckList,
    AboutUsSection,
  },
  mounted() {
    this.$telemetry.startTrackPage("patient_details.single");
  },
  beforeDestroy() {
    this.$telemetry.stopTrackPage("patient_details.single");
  },
  data() {
    return {
      bookingId: null,
      patientType: null,
      serviceType: null,
      serviceProvider: null,
      availability: null,
    };
  },
  computed: {
    style() {
      return {
        "--bg-color":
          this.$store.state.config?.colors?.containerBackground || "#FFFFFF",
      };
    },
  },
  methods: {
    onSubmit() {
      this.onNextStep(this.control?.locations?.location_id);
      this.$emit("go-to:step", 2);
      this.$emit("passed:step", 1);
      this.$emit("scroll-to", "top");
    },
    onInput(value) {
      this.$emit("update:field", { value: value.value, key: value.key });
    },
  },
};
</script>

<style scoped>
.bg-color {
  background-color: var(--bg-color);
}
</style>
